export const WORK_PANEL_VIEW_MODE_FULL = "fullscreen";
export const WORK_PANEL_VIEW_MODE_PANEL = "accordion";
export const WORK_PANEL_VIEW_MODE_DEFAULT = WORK_PANEL_VIEW_MODE_PANEL;

/**
 * @param {string|null|undefined} value
 * @returns {typeof WORK_PANEL_VIEW_MODE_FULL | typeof WORK_PANEL_VIEW_MODE_PANEL}
 */
export function resolveWorkPanelViewMode(value) {
    if (value === WORK_PANEL_VIEW_MODE_FULL) {
        return WORK_PANEL_VIEW_MODE_FULL;
    }

    if (value === WORK_PANEL_VIEW_MODE_PANEL) {
        return WORK_PANEL_VIEW_MODE_PANEL;
    }

    return WORK_PANEL_VIEW_MODE_DEFAULT;
}
